import MakeTag from "../makeTag/MakeTag";
export default function GodotTag() {
  return (<>
    <MakeTag tagText="Godot Engine" color="#478cbf" />
    <MakeTag tagText="Gdscript" color="#478cbf" />
  </>);
}